import { classNames } from "primereact/utils";
import { AdministrationIcon } from "./baseIcons/AdministrationIcon";
import { ArchiveIcon } from "./baseIcons/ArchiveIcon";
import { BurgerMenuIcon } from "./baseIcons/BurgerMenuIcon";
import { CardRefillIcon } from "./baseIcons/CardRefillIcon";
import { CheckmarkSentIcon } from "./baseIcons/CheckmarkSentIcon";
import { PlusIcon } from "./baseIcons/CirclePlusIcon";
import { ClockIcon } from "./baseIcons/ClockIcon";
import { DealIcon } from "./baseIcons/DealIcon";
import { DeleteIcon } from "./baseIcons/DeleteIcon";
import { DeleteIcon2 } from "./baseIcons/DeleteIcon2";
import { EditIcon } from "./baseIcons/EditIcon";
import { EmployeesIcon } from "./baseIcons/EmployeesIcon";
import { InValid } from "./baseIcons/InValid";
import { LogoutIcon } from "./baseIcons/LogoutIcon";
import { PayByCardIcon } from "./baseIcons/PayByCardIcon";
import { PlannerIcon } from "./baseIcons/PlannerIcon";
import { PlansIcon } from "./baseIcons/PlansIcon";
import { PutBackIcon } from "./baseIcons/PutBackIcon";
import { RightChevronIcon } from "./baseIcons/RightChevronIcon";
import { SendIcon } from "./baseIcons/SendIcon";
import { StudioIcon } from "./baseIcons/StudioIcon";
import { TwoCheckmarksDeliveredIcon } from "./baseIcons/TwoCheckmarksDeliveredIcon";
import { TwoCheckmarksSeenIcon } from "./baseIcons/TwoCheckmarksSeenIcon";
import { UsersIcon } from "./baseIcons/UsersIcon";
import { ValidIcon } from "./baseIcons/ValidIcon";
import styles from "./Icon.module.scss";
import { WarningIcon } from "./baseIcons/WarningIcon";
import { StatisticsIcon } from "./baseIcons/StatisticsIcon";
import { DuplicateIcon } from "./baseIcons/DuplicateIcon";
import { StudioRelationsIcon } from "./baseIcons/StudioRelationsIcon";
import { ArrowRightIcon } from "./baseIcons/ArrowRightIcon";
import { ArrowLeftIcon } from "./baseIcons/ArrowLeftIcon";
import { FamilyIcon } from "./baseIcons/FamilyIcon";
import { ColoredDeleteIcon } from "./baseIcons/ColoredDeleteIcon";
import { CancelIcon } from "./baseIcons/CancelIcon";
import { BackgroundGradient } from "./baseIcons/BackgroundGradient";
import { DollarIcon } from "./baseIcons/DollarIcon";
import { PersonIcon } from "./baseIcons/PersonIcon";
import { CalendarIcon } from "./baseIcons/CalendarIcon";
import { DumbellIcon } from "./baseIcons/DumbellIcon";
import { LocationIcon } from "./baseIcons/LocationIcon";
import { InformationIcon } from "./baseIcons/InformationIcon";
import { PhoneIcon } from "./baseIcons/PhoneIcon";
import { ViberIcon } from "./baseIcons/ViberIcon";
import { CrossedOutEye } from "./baseIcons/CrossedOutEye";
import { RecurringIcon } from "./baseIcons/RecurringIcon";
import { StarIcon } from "./baseIcons/StarIcon";
import { TrophyIcon } from "./baseIcons/TrophyIcon";
import { DollarIcon2 } from "./baseIcons/DollarIcon2";
import { WaitIcon } from "./baseIcons/WaitIcon";
import { CreditCardIcon } from "./baseIcons/CreditCardIcon";
import { GiftIcon } from "./baseIcons/GiftIcon";
import { ShieldIcon } from "./baseIcons/ShieldIcon";
import { LockIcon } from "./baseIcons/LockIcon";
import { MegaphoneIcon } from "./baseIcons/MegaphoneIcon";
import { DollarIcon3 } from "./baseIcons/DollarIcon3";
import { YogaIcon } from "./baseIcons/YogaIcon";
import { KeyIcon } from "./baseIcons/KeyIcon";
import { StackedCardsIcon } from "./baseIcons/StackedCardsIcon";
import { StoreIcon } from "./baseIcons/StoreIcon";
import { StoreIcon2 } from "./baseIcons/StoreIcon2";
import { LoginIcon } from "./baseIcons/LoginIcon";
import { CopyIcon } from "./baseIcons/CopyIcon";
import { EnvelopeIcon } from "./baseIcons/EnvelopeIcon";
import { EnvelopeIcon2 } from "./baseIcons/EnvelopeIcon2";
import { EnvelopeIcon3 } from "./baseIcons/EnvelopeIcon3";
import { FileIcon } from "./baseIcons/FileIcon";
import { NotesIcon } from "./baseIcons/NotesIcon";
import { PlusIcon2 } from "./baseIcons/PlusIcon2";
import { AddNoteIcon } from "./baseIcons/AddNoteIcon";
import { BlockedStopIcon } from "./baseIcons/BlockedStopIcon";
import { ScissorsIcon } from "./baseIcons/ScissorsIcon";
import { FiltersIcon } from "./baseIcons/FiltersIcon";
import { CookieIcon } from "./baseIcons/CookieIcon";
import { GraphIcon } from "./baseIcons/GraphIcon";
import { DragHandleIcon } from "./baseIcons/DragHandleIcon";
import { MoreOptionsIcon } from "./baseIcons/MoreOptionsIcon";
import { SearchIcon } from "./baseIcons/SearchIcon";
import { DocumentCheckIcon } from "./baseIcons/DocumentCheckIcon";
import { InvoiceIcon } from "./baseIcons/InvoiceIcon";
import { DownloadIcon } from "./baseIcons/DownloadIcon";
import { StripeIcon } from "./baseIcons/StripeIcon";
import { GoogleIcon } from "./baseIcons/GoogleIcon";
import { CameraIcon } from "./baseIcons/CameraIcon";
import { PaperclipIcon } from "./baseIcons/PaperclipIcon";
import { InventoryIcon } from "./baseIcons/InventoryIcon";
import { ProductsIcon } from "./baseIcons/ProductsIcon";
import { DeliveryIcon } from "./baseIcons/DeliveryIcon";
import { CashRegisterIcon } from "./baseIcons/CashRegisterIcon";
import { ExpandIcon } from "./baseIcons/ExpandIcon";
import { CollapseIcon } from "./baseIcons/CollapseIcon";
import { SparkleIcon } from "./baseIcons/SparkleIcon";
import { StopIcon } from "./baseIcons/StopIcon";
import { ChatBubblesIcon } from "./baseIcons/ChatBubblesIcon";
import { AppsIcon } from "./baseIcons/AppsIcon";

export enum IconType {
  SendIcon = "SendIcon",
  PlusIcon = "PlusIcon",
  TwoCheckmarksDeliveredIcon = "TwoCheckmarksDeliveredIcon",
  TwoCheckmarksSeenIcon = "TwoCheckmarksSeenIcon",
  RightChevronIcon = "RightChevronIcon",
  CheckmarkSentIcon = "CheckmarkSentIcon",
  ClockIcon = "ClockIcon",
  BurgerMenuIcon = "BurgerMenuIcon",
  PayByCardIcon = "PayByCardIcon",
  DeleteIcon = "DeleteIcon",
  DeleteIcon2 = "DeleteIcon2",
  EditIcon = "EditIcon",
  PlannerIcon = "PlannerIcon",
  CardRefillIcon = "CardRefillIcon",
  AdministrationIcon = "AdministrationIcon",
  UsersIcon = "UsersIcon",
  PlansIcon = "PlansIcon",
  EmployeesIcon = "EmployeesIcon",
  DealIcon = "DealIcon",
  StudioIcon = "StudioIcon",
  Logout = "Logout",
  Archive = "Archive",
  PutBackIcon = "PutBackIcon",
  Valid = "Valid",
  Invalid = "Invalid",
  Warning = "Warning",
  Statistics = "Statistics",
  Duplicate = "Duplicate",
  StudioRelations = "StudioRelations",
  ArrowRight = "ArrowRight",
  ArrowLeft = "ArrowLeft",
  Family = "Family",
  ColoredDelete = "ColoredDelete",
  Cancel = "Cancel",
  Background = "Background",
  Dollar = "Dollar",
  Person = "Person",
  Calendar = "Calendar",
  Dumbell = "Dumbell",
  Location = "Location",
  Information = "Information",
  Phone = "Phone",
  Viber = "Viber",
  CrossedOutEye = "CrossedOutEye",
  RecurringIcon = "RecurringIcon",
  Star = "StarIcon",
  Dollar2 = "DollarIcon2",
  Wait = "WaitIcon",
  CreditCard = "CreditCardIcon",
  Dollar3 = "DollarIcon3",
  Yoga = "YogaIcon",
  Key = "KeyIcon",
  StackedCards = "StackedCardsIcon",
  Store = "StoreIcon",
  Store2 = "StoreIcon2",
  Login = "LoginIcon",
  Copy = "CopyIcon",
  Envelope = "EnvelopeIcon",
  Envelope2 = "EnvelopeIcon2",
  Envelope3 = "EnvelopeIcon3",
  File = "FileIcon",
  Notes = "NotesIcon",
  Plus2 = "PlusIcon2",
  AddNote = "AddNoteIcon",
  BlockedStop = "BlockedStopIcon",
  Scissors = "ScissorsIcon",
  Filters = "FiltersIcon",
  Cookie = "CookieIcon",
  Graph = "GraphIcon",
  DragHandle = "DragHandleIcon",
  MoreOptions = "MoreOptionsIcon",
  Search = "SearchIcon",
  DocumentCheck = "DocumentCheckIcon",
  Invoice = "InvoiceIcon",
  Download = "DownloadIcon",
  Stripe = "StripeIcon",
  Google = "GoogleIcon",
  Camera = "CameraIcon",
  Paperclip = "PaperclipIcon",
  Inventory = "InventoryIcon",
  Products = "ProductsIcon",
  Delivery = "DeliveryIcon",
  CashRegister = "CashRegisterIcon",
  Trophy = "TrophyIcon",
  Expand = "ExpandIcon",
  Collapse = "CollapseIcon",
  Gift = "GiftIcon",
  Shield = "ShieldIcon",
  Lock = "LockIcon",
  Sparkle = "SparkleIcon",
  Stop = "StopIcon",
  ChatBubbles = "ChatBubblesIcon",
  Megaphone = "MegaphoneIcon",
  Apps = "AppsIcon",
}

export interface IIconProps {
  className?: string;
  type: IconType;
  height?: string | number;
  width?: string | number;
  color?: string;
  backgroundColor?: string;
}

export const Icon = ({
  className,
  type,
  height = "20px",
  width = "20px",
  color,
  backgroundColor,
}: IIconProps) => {
  const baseIcons: { [key in IconType]: JSX.Element } = {
    [IconType.SendIcon]: (
      <SendIcon color={color} backgroundColor={backgroundColor} />
    ),
    [IconType.PlusIcon]: (
      <PlusIcon color={color} backgroundColor={backgroundColor} />
    ),
    [IconType.TwoCheckmarksDeliveredIcon]: (
      <TwoCheckmarksDeliveredIcon
        color={color}
        backgroundColor={backgroundColor}
      />
    ),
    [IconType.TwoCheckmarksSeenIcon]: (
      <TwoCheckmarksSeenIcon color={color} backgroundColor={backgroundColor} />
    ),
    [IconType.RightChevronIcon]: (
      <RightChevronIcon color={color} backgroundColor={backgroundColor} />
    ),
    [IconType.CheckmarkSentIcon]: (
      <CheckmarkSentIcon color={color} backgroundColor={backgroundColor} />
    ),
    [IconType.ClockIcon]: (
      <ClockIcon color={color} backgroundColor={backgroundColor} />
    ),
    [IconType.BurgerMenuIcon]: (
      <BurgerMenuIcon color={color} backgroundColor={backgroundColor} />
    ),
    [IconType.PayByCardIcon]: (
      <PayByCardIcon color={color} backgroundColor={backgroundColor} />
    ),
    [IconType.DeleteIcon]: (
      <DeleteIcon color={color} backgroundColor={backgroundColor} />
    ),
    [IconType.DeleteIcon2]: (
      <DeleteIcon2 color={color} backgroundColor={backgroundColor} />
    ),
    [IconType.EditIcon]: (
      <EditIcon color={color} backgroundColor={backgroundColor} />
    ),
    [IconType.PlannerIcon]: (
      <PlannerIcon color={color} backgroundColor={backgroundColor} />
    ),
    [IconType.CardRefillIcon]: (
      <CardRefillIcon color={color} backgroundColor={backgroundColor} />
    ),
    [IconType.AdministrationIcon]: (
      <AdministrationIcon color={color} backgroundColor={backgroundColor} />
    ),
    [IconType.UsersIcon]: (
      <UsersIcon color={color} backgroundColor={backgroundColor} />
    ),
    [IconType.PlansIcon]: (
      <PlansIcon color={color} backgroundColor={backgroundColor} />
    ),
    [IconType.EmployeesIcon]: (
      <EmployeesIcon color={color} backgroundColor={backgroundColor} />
    ),
    [IconType.DealIcon]: <DealIcon />,
    [IconType.StudioIcon]: <StudioIcon />,
    [IconType.Logout]: <LogoutIcon />,
    [IconType.Archive]: <ArchiveIcon color={color} />,
    [IconType.PutBackIcon]: <PutBackIcon />,
    [IconType.Valid]: <ValidIcon color={color} />,
    [IconType.Invalid]: <InValid />,
    [IconType.Warning]: <WarningIcon color={color} />,
    [IconType.Statistics]: <StatisticsIcon color={color} />,
    [IconType.Duplicate]: <DuplicateIcon />,
    [IconType.StudioRelations]: <StudioRelationsIcon />,
    [IconType.ArrowRight]: <ArrowRightIcon />,
    [IconType.ArrowLeft]: <ArrowLeftIcon />,
    [IconType.Family]: <FamilyIcon color={color} />,
    [IconType.ColoredDelete]: <ColoredDeleteIcon />,
    [IconType.Cancel]: <CancelIcon color={color} />,
    [IconType.Background]: (
      <BackgroundGradient color={color} backgroundColor={backgroundColor} />
    ),
    [IconType.Dollar]: <DollarIcon />,
    [IconType.Person]: <PersonIcon color={color} />,
    [IconType.Calendar]: <CalendarIcon color={color} />,
    [IconType.Dumbell]: <DumbellIcon color={color} />,
    [IconType.Location]: <LocationIcon color={color} />,
    [IconType.Information]: <InformationIcon color={color} />,
    [IconType.Phone]: <PhoneIcon color={color} />,
    [IconType.Viber]: <ViberIcon />,
    [IconType.CrossedOutEye]: <CrossedOutEye />,
    [IconType.RecurringIcon]: <RecurringIcon />,
    [IconType.Star]: <StarIcon color={color} />,
    [IconType.Dollar2]: <DollarIcon2 />,
    [IconType.Wait]: <WaitIcon color={color} />,
    [IconType.CreditCard]: <CreditCardIcon color={color} />,
    [IconType.Gift]: <GiftIcon color={color} />,
    [IconType.Shield]: <ShieldIcon color={color} />,
    [IconType.Lock]: <LockIcon color={color} />,
    [IconType.Megaphone]: <MegaphoneIcon color={color} />,
    [IconType.Dollar3]: <DollarIcon3 color={color} />,
    [IconType.Yoga]: <YogaIcon />,
    [IconType.Key]: <KeyIcon />,
    [IconType.StackedCards]: <StackedCardsIcon />,
    [IconType.Store]: <StoreIcon color={color} />,
    [IconType.Store2]: <StoreIcon2 />,
    [IconType.Login]: <LoginIcon />,
    [IconType.Copy]: <CopyIcon />,
    [IconType.Envelope]: <EnvelopeIcon color={color} />,
    [IconType.Envelope2]: <EnvelopeIcon2 color={color} />,
    [IconType.Envelope3]: <EnvelopeIcon3 color={color} />,
    [IconType.File]: <FileIcon color={color} />,
    [IconType.Notes]: <NotesIcon color={color} />,
    [IconType.Plus2]: <PlusIcon2 color={color} />,
    [IconType.AddNote]: <AddNoteIcon color={color} />,
    [IconType.BlockedStop]: <BlockedStopIcon />,
    [IconType.Scissors]: <ScissorsIcon />,
    [IconType.Filters]: <FiltersIcon />,
    [IconType.Cookie]: <CookieIcon color={color} />,
    [IconType.Graph]: <GraphIcon />,
    [IconType.DragHandle]: <DragHandleIcon color={color} />,
    [IconType.MoreOptions]: <MoreOptionsIcon color={color} />,
    [IconType.Search]: <SearchIcon color={color} />,
    [IconType.DocumentCheck]: <DocumentCheckIcon color={color} />,
    [IconType.Invoice]: <InvoiceIcon color={color} />,
    [IconType.Download]: <DownloadIcon color={color} />,
    [IconType.Stripe]: <StripeIcon />,
    [IconType.Google]: <GoogleIcon />,
    [IconType.Camera]: <CameraIcon color={color} />,
    [IconType.Paperclip]: <PaperclipIcon color={color} />,
    [IconType.Inventory]: <InventoryIcon color={color} />,
    [IconType.Products]: <ProductsIcon color={color} />,
    [IconType.Delivery]: <DeliveryIcon color={color} />,
    [IconType.CashRegister]: <CashRegisterIcon color={color} />,
    [IconType.Trophy]: <TrophyIcon color={color} />,
    [IconType.Expand]: <ExpandIcon color={color} />,
    [IconType.Collapse]: <CollapseIcon color={color} />,
    [IconType.Sparkle]: <SparkleIcon color={color} />,
    [IconType.Stop]: <StopIcon color={color} />,
    [IconType.ChatBubbles]: <ChatBubblesIcon color={color} />,
    [IconType.Apps]: <AppsIcon color={color} />,
  };

  return (
    <div
      className={classNames(styles.root, className)}
      style={{ width, height }}
    >
      {baseIcons[type]}
    </div>
  );
};
